import copImg from "../../assets/images/svg/blockedCop.svg";
import arrowIcon from "../../assets/images/svg/arrowLeftWhite.svg";
import Header from "../../components/Header/Header";
import { useNavigate } from "react-router";
import { Observer, observer } from "mobx-react";
import AuthStore from "../../store/AuthStore";
import { useEffect, useState } from "react";
import PageHeading from "../../components/PageHeading/PageHeading";

const Blocked = observer(() => {
  const navigate = useNavigate();

  const [timeOfDayGreeting, setTimeOfDayGreeting] = useState("");

  useEffect(() => {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      setTimeOfDayGreeting("Good morning");
    } else if (currentHour >= 12 && currentHour < 18) {
      setTimeOfDayGreeting("Good afternoon");
    } else {
      setTimeOfDayGreeting("Good evening");
    }
  }, []);

  const getDefaultImage = (name) => {
    return <div className="profileImageDefault2">{name ? name[0] : ""}</div>;
  };

  return (
    <Observer>
      {() => (
        <>
          <Header isLogoNavigationEnabled={false} />
          <div className="blocked_outer">
            <div className="main_div_blocked">
              <>
                {AuthStore?.selectFamiliesPageAllImages?.[
                  AuthStore?.blockedUserData?.client?.user_id
                ] ? (
                  <img
                    className="member_profile"
                    src={
                      AuthStore?.selectFamiliesPageAllImages?.[
                        AuthStore?.blockedUserData?.client?.user_id
                      ]
                    }
                    alt=""
                  />
                ) : (
                  getDefaultImage(AuthStore?.blockedUserData?.client?.full_name)
                )}
              </>
              <p className="heading">
                {timeOfDayGreeting}{" "}
                {AuthStore.blockedUserData?.client?.full_name}{" "}
              </p>
              <div className="e_image">
                <img src={copImg} alt="Account blocked img" />
              </div>
              <PageHeading
                headingClass="warning"
                headingText="Your Account Has Been Locked"
              />
              <p className="wrong_mpin">
                We’ve noticed that the wrong MPIN has been entered more than 3
                times in your mobile device
              </p>
              <p className="unblock_label">
                Kindly follow the steps in your mobile device to unblock your
                Account
              </p>

              <div className="button_container">
                <button
                  className="button"
                  onClick={() => navigate("/login/user")}
                >
                  <img src={arrowIcon} alt="arrow" />
                </button>
                <p className="button_text">Go Back to Login Page</p>
              </div>
            </div>
          </div>
        </>
      )}
    </Observer>
  );
});

export default Blocked;
